import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=d6d0c2e4&scoped=true"
import script from "./WarningDialog.vue?vue&type=script&lang=js"
export * from "./WarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d0c2e4",
  null
  
)

export default component.exports